import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {AlertService} from "@app/_services";
import {SharedService} from "@app/_components/_shared/shared.service";
import {ApiResponse} from "@app/_models";
import {environment} from "@environments/environment";
import {retry, timeout} from "rxjs/operators";
import { Observable } from 'rxjs';
import {OrderDetail} from "@app/_components/reservation/components/reservation/order-detail/order-detail";

@Injectable({
  providedIn: 'root'
})
export class OwnerStmtService {

  stmtStatus: any[] = [
    { value: 0, label: 'Default' },
    { value: 1, label: 'Draft' },
    { value: 2, label: 'NeedAttention' },
    { value: 3, label: 'ReadyForReview1' },
    { value: 4, label: 'ReadyForReview2' },
    { value: 5, label: 'ReadyForReview3' },
    { value: 6, label: 'Approved' },
    { value: 7, label: 'Published' }
  ];

  stmtStatusWithoutPublished: any[] = [
    { value: 0, label: 'Default' },
    { value: 1, label: 'Draft' },
    { value: 2, label: 'NeedAttention' },
    { value: 3, label: 'ReadyForReview1' },
    { value: 4, label: 'ReadyForReview2' },
    { value: 5, label: 'ReadyForReview3' },
    { value: 6, label: 'Approved' }
  ];

  years: any[] = [
    { value: '2025', name: '2025' },
    { value: '2026', name: '2026' },
    { value: '2027', name: '2027' },
    { value: '2028', name: '2028' },
    { value: '2029', name: '2029' },
    { value: '2030', name: '2030' },
    { value: '2031', name: '2031' },
    { value: '2032', name: '2032' },
    { value: '2033', name: '2033' },
    { value: '2034', name: '2034' },
    { value: '2035', name: '2035' },
    { value: '2036', name: '2036' },
    { value: '2037', name: '2037' },
    { value: '2038', name: '2038' },
    { value: '2039', name: '2039' },
    { value: '2040', name: '2040' },
    { value: '2041', name: '2041' },
  ]

  months: any[] = [
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' },
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' },
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' },
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' },
  ]

  monthsForBulkGenerateStatement: any[] = [
    // { value: '01', name: '01' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    // { value: '07', name: '07' },
    // { value: '08', name: '08' },
    // { value: '09', name: '09' },
    // { value: '10', name: '10' },
    // { value: '11', name: '11' },
    // { value: '12', name: '12' },
  ]

  yearsForBulkGenerateStatement: any[] = [
    { value: 2025, name: '2025' },
    { value: 2026, name: '2026' },
    // { value: '2027', name: '2027' },
    // { value: '2028', name: '2028' },
    // { value: '2029', name: '2029' },
    // { value: '2030', name: '2030' },
    // { value: '2031', name: '2031' },
    // { value: '2032', name: '2032' },
    // { value: '2033', name: '2033' },
    // { value: '2034', name: '2034' },
    // { value: '2035', name: '2035' },
    // { value: '2036', name: '2036' },
    // { value: '2037', name: '2037' },
    // { value: '2038', name: '2038' },
    // { value: '2039', name: '2039' },
    // { value: '2040', name: '2040' },
    // { value: '2041', name: '2041' },
  ]
  constructor
  (
    private http: HttpClient,
    private alertService: AlertService,
    private sharedService: SharedService
  ) { }

  urlEndpoint = 'owner-stmts';
  urlEndpoint1 = 'owner-stmt-rez';
  createOwnerStatementEndpoint = 'owner-stmt-details';
  regenerateStmt = 'owner-stmt-rez/re-generate-stmt/'; // {ownerStmtId}

  findById(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`);
  }

  findStmtById(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/owner-stmts-pdf-preview/${id}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  getPdfAsBlob(ownerStmtId: number): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/${this.urlEndpoint}/${ownerStmtId}/pdf`, {
      responseType: 'blob'
    }).pipe(timeout(45000));
  }

  getOwnerEmail(ownerStmtId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/get-owner-email/${ownerStmtId}`).pipe(retry(1));
  }

  findStmtListFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
    let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params })
  }

  generateStatement(obj): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint1}/generate-stmt/${obj.shortTermRentalId}/${obj.month}/${obj.year}`);
  }

  generateStatementByDate(obj: any): Observable<ApiResponse> {
    console.log('posting... ' + JSON.stringify(obj));
    return this.http.post<ApiResponse>(`${environment.apiUrl}/owner-stmt-rez/generate-stmt`, obj);
  }

  generateBulkStatement(month: any, year: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint1}/generate-stmt/${month}/${year}`,{});
  }

  regenerateBulkStatement(month: number, year: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint1}/regenerate-stmt/${month}/${year}`,{});
  }

  regenerateStmtExpenses(month: number, year: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint1}/regenerate-stmt-exp/${month}/${year}`,{});
  }

  /**
   * Dashboard: post-generation gap counts, status totals, email/payment/NACHA progress.
   * Powers the dashboard band at the top of /owner-statements.
   */
  getDashboard(month: number, year: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/dashboard/${month}/${year}`);
  }

  /** Bulk lock all unlocked reservation ledger rows in the period. */
  dashboardLockLedgers(month: number, year: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      `${environment.apiUrl}/${this.urlEndpoint}/dashboard/${month}/${year}/lock-ledgers`, {});
  }

  /** Bulk advance all eligible APPROVED expenses to REVIEWED for the period. */
  dashboardSetExpensesReviewed(month: number, year: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      `${environment.apiUrl}/${this.urlEndpoint}/dashboard/${month}/${year}/set-expenses-reviewed`, {});
  }

  /** Drill-down lists behind dashboard tiles. */
  dashboardDrillExpenseBlockers(month: number, year: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${environment.apiUrl}/${this.urlEndpoint}/dashboard/${month}/${year}/expense-blockers`);
  }
  dashboardDrillUnlockedReservations(month: number, year: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${environment.apiUrl}/${this.urlEndpoint}/dashboard/${month}/${year}/unlocked-reservations`);
  }
  dashboardDrillQualifyingOx(month: number, year: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${environment.apiUrl}/${this.urlEndpoint}/dashboard/${month}/${year}/qualifying-ox`);
  }

  /** Drill-down: ALL expenses with NULL stmtBilledDate (Pending Billing watchlist). */
  dashboardDrillPendingBilling(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${environment.apiUrl}/${this.urlEndpoint}/dashboard/pending-billing`);
  }

  /** Drill-down: reservations missing OWNER_AMOUNT or KBM_MANAGEMENT_FEE rows. */
  dashboardDrillMissingLedgerRows(month: number, year: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${environment.apiUrl}/${this.urlEndpoint}/dashboard/${month}/${year}/missing-ledger-rows`);
  }

  /** Pre-Publish QC: bundles all critical checks into one health call. */
  dashboardPrePublishQc(month: number, year: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      `${environment.apiUrl}/${this.urlEndpoint}/dashboard/${month}/${year}/pre-publish-qc`);
  }

  add(orderDetail: any): Observable<ApiResponse> {
    console.log('posting... ' + JSON.stringify(orderDetail));
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.createOwnerStatementEndpoint}`, orderDetail);
  }

  update(orderDetail: any): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.createOwnerStatementEndpoint}`, orderDetail);
  }

  delete(developmentId: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.createOwnerStatementEndpoint}/${developmentId}`);
  }

  deleteOwnerStatement(ownerStmtId: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${ownerStmtId}`);
  }

  regenerateStatement(ownerStmtId: any) {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.regenerateStmt}${ownerStmtId}`,{});
  }

  findStmtOrderProduct(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/order-products/ledger/list`);
  }

  updateOwnerStmtStatus(ownerStmtId: any, status: any) {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/owner-stmts/update-status/${ownerStmtId}/${status}`);
  }

  bulkUpdateStatus(bulkUpdateData: any): Observable<ApiResponse> {
    console.log('Bulk update posting... ' + JSON.stringify(bulkUpdateData));
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/owner-stmts-bulk-status-update`, bulkUpdateData);
  }

  bulkMailStatements(
    ownerStmtIds: number[],
    password: string,
    auditInfo: {
      confirmedByUsername: string;
      confirmedByName: string;
      confirmedAt: string;
      statementPeriod: string;
      checklistItems: Record<string, boolean>;
    }
  ): Observable<ApiResponse> {
    const body = {
      ownerStmtIds,
      password,
      confirmedByUsername: auditInfo.confirmedByUsername,
      confirmedByName: auditInfo.confirmedByName,
      confirmedAt: auditInfo.confirmedAt,
      statementPeriod: auditInfo.statementPeriod,
      checklistItems: auditInfo.checklistItems
    };
    return this.http.post<ApiResponse>(`${environment.apiUrl}/owner-stmts/bulk-send-email`, body);
  }

  /** Mark a statement as manually paid (check, wire, etc.). */
  markManualPaid(ownerStmtId: number, payload: { paymentStatus: string; paymentMethod: string; paidDate: string; paymentReference?: string }): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${ownerStmtId}/payment-status`, payload);
  }

  updateOwnerNotes(updateData: any): Observable<ApiResponse> {
    console.log('Updating owner notes... ' + JSON.stringify(updateData));
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/owner-stmts/owner-notes`, updateData);
  }

  getAllExpensesForMonth(month: number, year: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/expenses-by-month/${month}/${year}`);
  }

  /** Add a qualifying OX reservation to the owner statement (full or partial). */
  addOxReservationToStmt(reservationId: number, month: number, year: number, revenueAmt?: number): Observable<any> {
    const body: any = { reservationId, month, year };
    if (revenueAmt !== undefined && revenueAmt !== null) {
      body.revenueAmt = revenueAmt;
    }
    return this.http.post<any>(`${environment.apiUrl}/owner-stmt-rez/add-reservation-into-stmt`, body);
  }

  /** Permanently exclude an OX reservation from its owner statement. */
  excludeOxRez(ownerStmtId: number, reservationId: number, month: number, year: number, notes?: string): Observable<any> {
    const body: any = { ownerStmtId, reservationId, notes: notes || null };
    return this.http.post<any>(`${environment.apiUrl}/owner-stmts/dashboard/${month}/${year}/exclude-rez`, body);
  }
}
